// https://developer.fastly.com/reference/io/#query-parameters
export default function imageLoader({ src, width }) {
  return `${src}?auto=webp&optimize=high&width=${width}`
}
